<ul class="crm-timeline">
  <li *ngFor="let a of activities" class="crm-event" [class.is-auto]="isAuto(a.type)">
    <div class="event-head">
      <span class="event-type">{{ typeLabel(a.type) }}</span>
      <span class="event-when">{{ a.occurred_at | date:'short' }}</span>
      <span class="event-who" *ngIf="who(a) as w">· {{ w }}</span>
      <span class="event-actions" *ngIf="canEdit && !isAuto(a.type) && editingId !== a.id">
        <button nbButton ghost size="tiny" type="button" (click)="startEdit(a)">{{ 'edit' | translate }}</button>
        <button nbButton ghost size="tiny" status="danger" type="button" (click)="remove(a)">{{ 'delete' | translate }}</button>
      </span>
    </div>
    <p class="event-body" *ngIf="a.body && editingId !== a.id">{{ a.body }}</p>
    <div class="event-edit" *ngIf="editingId === a.id">
      <div class="event-edit-when">
        <input nbInput fieldSize="small" class="edit-date"
               [placeholder]="'enterdate' | translate"
               [attr.title]="'crm.occurred_at' | translate"
               [nbDatepicker]="editDatePicker"
               [(ngModel)]="editDate"
               (ngModelChange)="editDateTouched = true">
        <nb-datepicker #editDatePicker [max]="today"></nb-datepicker>
        <input nbInput fieldSize="small" type="time" class="edit-time"
               [attr.title]="'crm.occurred_at' | translate"
               [(ngModel)]="editTime"
               (ngModelChange)="editDateTouched = true"
               *ngIf="editDate">
      </div>
      <textarea nbInput fullWidth rows="3" [(ngModel)]="editBody"></textarea>
      <div class="event-edit-actions">
        <button nbButton ghost size="tiny" type="button" (click)="cancelEdit()">{{ 'cancel' | translate }}</button>
        <button nbButton size="tiny" status="primary" type="button" [disabled]="!editBody.trim()" (click)="saveEdit()">{{ 'save' | translate }}</button>
      </div>
    </div>
  </li>
</ul>
